import { useState } from "react";

export default function ShareButtons({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);
  const encoded = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  async function copy() {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  }

  const chipClass =
    "rounded-full border border-[rgba(17,17,17,0.15)] px-4 py-2 text-sm text-[#333333] hover:bg-white/60 transition-colors";

  return (
    <div className="flex flex-wrap gap-2">
      <button type="button" onClick={() => void copy()} className={chipClass}>
        {copied ? "Copied" : "Copy link"}
      </button>
      <a
        href={`https://twitter.com/intent/tweet?url=${encoded}&text=${encodedTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        className={chipClass}
      >
        Share on X
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`}
        target="_blank"
        rel="noopener noreferrer"
        className={chipClass}
      >
        LinkedIn
      </a>
    </div>
  );
}
